import { keyframes, css } from '@creditas/stylitas'

import { rtNamespace } from '../variables'

const flipIn = keyframes`
from {
  transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
  animation-timing-function: ease-in;
  opacity: 0;
}
40% {
  transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
  animation-timing-function: ease-in;
}
60% {
  transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
  opacity: 1;
}
80% {
  transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
}
to {
  transform: perspective(400px);
}
`

const flipOut = keyframes`
  from {
    transform: perspective(400px);
  }
  30% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }
  to {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
`

const flip = css`
  .${rtNamespace}__flip-enter {
    animation-name: ${flipIn};
  }

  .${rtNamespace}__flip-exit {
    animation-name: ${flipOut};
  }
`

export { flip }
